/**
 * Customer Main Type Constants
 * Source: login_types table (unique_id column)
 * Used for customer network hierarchy (Primary -> Secondary -> Tertiary -> Influencer)
 *
 * Database login_types:
 * - 100: INFLUENCER
 * - 101: PRIMARY_CUSTOMER
 * - 102: SECONDARY_CUSTOMER
 * - 103: TERTIARY_CUSTOMER
 * - 200: KODIA_DEALER      (Kodia org=7 field role — view-only, no wallet; JBN org=15 reuses)
 * - 201: KODIA_ARCHITECT   (Kodia org=7 field role — view-only, no wallet; JBN org=15 reuses)
 * - 202: KODIA_CUSTOMER    (Kodia org=7 field role — view-only, no wallet)
 * - 203: INTERIOR_DESIGNER (JBN org=15 field role — view-only, no wallet)
 * - 204: CONTRACTOR        (JBN org=15 field role — view-only, no wallet)
 */

export const CUSTOMER_MAIN_TYPE_ID = {
  INFLUENCER: 100,
  PRIMARY: 101,
  SECONDARY: 102,
  TERTIARY: 103,
  KODIA_DEALER: 200,
  KODIA_ARCHITECT: 201,
  KODIA_CUSTOMER: 202,
  INTERIOR_DESIGNER: 203,
  CONTRACTOR: 204,
} as const;

export const CUSTOMER_MAIN_TYPE_NAMES: Record<number, string> = {
  100: 'Influencer',
  101: 'Primary (Distributor)',
  102: 'Secondary (Retailer)',
  103: 'Tertiary (Sub-Dealer)',
  200: 'Dealer',
  201: 'Architect',
  202: 'Customer',
  203: 'Interior Designer',
  204: 'Contractor',
};

export const CUSTOMER_MAIN_TYPE_CODES: Record<number, string> = {
  100: 'INFLUENCER',
  101: 'PRIMARY',
  102: 'SECONDARY',
  103: 'TERTIARY',
  200: 'KODIA_DEALER',
  201: 'KODIA_ARCHITECT',
  202: 'KODIA_CUSTOMER',
  203: 'INTERIOR_DESIGNER',
  204: 'CONTRACTOR',
};

export const CUSTOMER_MAIN_TYPE_COLORS: Record<number, string> = {
  100: 'warning',
  101: 'primary',
  102: 'success',
  103: 'info',
  200: 'primary',
  201: 'info',
  202: 'success',
  203: 'warning',
  204: 'primary',
};

// Type for Customer Main Type ID values
export type CustomerMainTypeIdValue = typeof CUSTOMER_MAIN_TYPE_ID[keyof typeof CUSTOMER_MAIN_TYPE_ID];
